<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>You can't change user's payment information.</div>
  <!-- <div id="user-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2">

        Col Header 
        <div class="flex items-end">
          <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Payment Information</span>
        </div>

        Col Content 
        <div>
          <div class="mt-4">
            <label class="text-sm">Payment Method</label>
            <v-select v-model="data_local.type" :closeOnSelect="false" :options="method" v-validate="'required'" name="lang_known" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            <span class="text-danger text-sm"  v-show="errors.has('lang_known')">{{ errors.first('lang_known') }}</span>
          </div>
          <div v-if="data_local.type == 'Payoneer'">
            <div class="mt-4">
              <label class="text-sm">Currency</label>
              <v-select v-model="data_local.currency" :closeOnSelect="false" :options="currency" v-validate="'required'" name="lang_known" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm"  v-show="errors.has('lang_known')">{{ errors.first('lang_known') }}</span>
            </div>

            <vs-input class="w-full mt-4" label="Payoneer Address" v-model="data_local.account" v-validate="'required|alpha'" name="account" />
            <span class="text-danger text-sm"  v-show="errors.has('account')">{{ errors.first('account') }}</span>

            <div class="mt-4">
              <label class="text-sm">Status</label>
              <div class="mt-2">
                <vs-radio v-model="data_local.Status" vs-value="Approved" class="mr-4">Approved</vs-radio>
                <vs-radio v-model="data_local.Status" vs-value="Rejected" class="mr-4">Rejected</vs-radio>
              </div>
            </div>

            <vs-input v-if="data_local.Status == 'Rejected'" class="w-full mt-4" label="Reason" v-model="data_local.reason" name="reason" />
          </div>
          
          <div v-if="data_local.type == 'SEFA'">
            <div class="mt-4">
              <label class="text-sm">Currency</label>
              <v-select v-model="data_local.currency" :closeOnSelect="false" :options="currency" v-validate="'required'" name="lang_known" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm"  v-show="errors.has('lang_known')">{{ errors.first('lang_known') }}</span>
            </div>

            <vs-input class="w-full mt-4" label="IBAN" v-model="data_local.account" v-validate="'required|alpha'" name="account" />
            <span class="text-danger text-sm"  v-show="errors.has('account')">{{ errors.first('account') }}</span>

            <div class="mt-4">
              <label class="text-sm">Country of your bank</label>
              <v-select v-model="countrytext" :closeOnSelect="false" :options="country" v-validate="'required'" name="lang_known" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm"  v-show="errors.has('lang_known')">{{ errors.first('lang_known') }}</span>
            </div>

            <div class="mt-4">
              <label class="text-sm">Status</label>
              <div class="mt-2">
                <vs-radio v-model="data_local.Status" vs-value="Approved" class="mr-4">Approved</vs-radio>
                <vs-radio v-model="data_local.Status" vs-value="Rejected" class="mr-4">Rejected</vs-radio>
              </div>
            </div>

            <vs-input v-if="data_local.Status == 'Rejected'" class="w-full mt-4" label="Reason" v-model="data_local.reason" name="reason" />
          </div>
          
          <div v-if="data_local.type == 'Techer'">
            <div class="mt-4">
              <label class="text-sm">Network</label>
              <v-select v-model="data_local.currency" :closeOnSelect="false" :options="network" v-validate="'required'" name="lang_known" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm"  v-show="errors.has('lang_known')">{{ errors.first('lang_known') }}</span>
            </div>

            <vs-input class="w-full mt-4" label="Crypto Wallet Address" v-model="data_local.account" v-validate="'required|alpha'" name="account" />
            <span class="text-danger text-sm"  v-show="errors.has('account')">{{ errors.first('account') }}</span>

            <div class="mt-4">
              <label class="text-sm">Status</label>
              <div class="mt-2">
                <vs-radio v-model="data_local.Status" vs-value="Approved" class="mr-4">Approved</vs-radio>
                <vs-radio v-model="data_local.Status" vs-value="Rejected" class="mr-4">Rejected</vs-radio>
              </div>
            </div>

            <vs-input v-if="data_local.Status == 'Rejected'" class="w-full mt-4" label="Reason" v-model="data_local.reason" name="reason" />
          </div>
          DOB 
        </div>
      </div>
    </div>

    Save & Reset Button 
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
    flatPickr
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

      data_local: JSON.parse(JSON.stringify(this.data.paymentinfo)),

      langOptions: [
        { label: 'English',  value: 'english'  },
        { label: 'Spanish',  value: 'spanish'  },
        { label: 'French',   value: 'french'   },
        { label: 'Russian',  value: 'russian'  },
        { label: 'German',   value: 'german'   },
        { label: 'Arabic',   value: 'arabic'   },
        { label: 'Sanskrit', value: 'sanskrit' }
      ],
      
      // method: [
      //   { label: 'Payoneer',  value: 'Payoneer'  },
      //   { label: 'SEFA',  value: 'SEFA'  },
      //   { label: 'Techer',   value: 'Techer'   }
      // ],
      method: ['Payoneer', 'SEFA', 'Techer'],
      currency: ['EUR €', 'USD $'],
      network: ['ERC20', 'BEP20'],
      country: ['The Netherlands','The United States','The Tailland','The Ukriane'],
      countrytext: ''

      // currency: [
      //   { label: 'EUR €', value: 'EUR €'},
      //   { label: 'USD $', value: 'USD $'}
      // ],

      // network: [
      //   { label: 'ERC20', value: 'ERC20'},
      //   { label: 'BEP20', value: 'BEP20'}
      // ]


    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.data_local"


    const countrynumber = (this.countrytext == "The Netherlands") ? 0 : (this.countrytext == 'The United States') ? 1 : (this.countrytext == 'The Tailland') ? 2 : 3
    const reasontext = (!this.data_local.reason) ? "" : (this.data_local.Status == 'Approved') ? "" : this.data_local.reason
    

      const payload = {
        _id: this.data_local._id,
        type: this.data_local.type,
        currency: this.data_local.currency,
        account: this.data_local.account,
        country: countrynumber,
        status: this.data_local.Status,
        reason: reasontext
        
      };
      // sending file to the backendthis.$store
      this.$store
        .dispatch("userManagement/updatePayment", payload)
        .then((res) => {
          this.$router.push({ name: "User List" });
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "User Upload Failed!",
            text: res.message,
          });
          console.error(err);
        });

    },
    reset_data () {
      this.data_local = Object.assign({}, this.data.paymentinfo)
    }
  },
  created() {
    this.countrytext = (this.data_local.country == 0) ? "The Netherlands" : (this.data_local.country == 1) ? 'The United States' : (this.data_local.country == 2) ? 'The Tailland' : 'The Ukriane'
  }
}
</script>
